/**
 * 配置块 JSON Schema 统一导出
 */
import { npcSchema, type NpcConfig } from './npc.schema'
import { questSchema, type QuestConfig } from './quest.schema'
import { variableSchema, type VariableConfig } from './variable.schema'

// 其他 Schema 的占位符（待实现）
import { itemSchema, type ItemConfig } from './item.schema'
import { timelineSchema, type TimelineConfig } from './timeline.schema'
import { worldSchema, type WorldConfig } from './world.schema'
import { factionSchema, type FactionConfig } from './faction.schema'
import { locationSchema, type LocationConfig } from './location.schema'
import { actionSchema, type ActionConfig } from './action.schema'
import { eventSchema, type EventConfig } from './event.schema'
import { dialogueSchema, type DialogueConfig } from './dialogue.schema'
import { aiModelSchema, type AiModelConfig } from './ai_model.schema'

/**
 * 配置类型枚举
 */
export enum ConfigType {
  NPC = 'npc',
  QUEST = 'quest',
  ITEM = 'item',
  VARIABLE = 'variable',
  TIMELINE = 'timeline',
  WORLD = 'world',
  FACTION = 'faction',
  LOCATION = 'location',
  ACTION = 'action',
  EVENT = 'event',
  DIALOGUE = 'dialogue',
  AI_MODEL = 'ai_model',
}

/**
 * Schema 映射表
 */
export const schemaMap = {
  [ConfigType.NPC]: npcSchema,
  [ConfigType.QUEST]: questSchema,
  [ConfigType.ITEM]: itemSchema,
  [ConfigType.VARIABLE]: variableSchema,
  [ConfigType.TIMELINE]: timelineSchema,
  [ConfigType.WORLD]: worldSchema,
  [ConfigType.FACTION]: factionSchema,
  [ConfigType.LOCATION]: locationSchema,
  [ConfigType.ACTION]: actionSchema,
  [ConfigType.EVENT]: eventSchema,
  [ConfigType.DIALOGUE]: dialogueSchema,
  [ConfigType.AI_MODEL]: aiModelSchema,
} as const

/**
 * 根据配置类型获取对应的 JSON Schema
 */
export function getSchemaByType(configType: ConfigType | string) {
  return schemaMap[configType as ConfigType] || null
}

/**
 * 配置类型的 TypeScript 类型映射
 */
export type ConfigDataType = {
  [ConfigType.NPC]: NpcConfig
  [ConfigType.QUEST]: QuestConfig
  [ConfigType.ITEM]: ItemConfig
  [ConfigType.VARIABLE]: VariableConfig
  [ConfigType.TIMELINE]: TimelineConfig
  [ConfigType.WORLD]: WorldConfig
  [ConfigType.FACTION]: FactionConfig
  [ConfigType.LOCATION]: LocationConfig
  [ConfigType.ACTION]: ActionConfig
  [ConfigType.EVENT]: EventConfig
  [ConfigType.DIALOGUE]: DialogueConfig
  [ConfigType.AI_MODEL]: AiModelConfig
}

/**
 * 导出所有 Schema
 */
export {
  npcSchema,
  questSchema,
  itemSchema,
  variableSchema,
  timelineSchema,
  worldSchema,
  factionSchema,
  locationSchema,
  actionSchema,
  eventSchema,
  dialogueSchema,
  aiModelSchema,
}

/**
 * 导出所有 TypeScript 类型
 */
export type {
  NpcConfig,
  QuestConfig,
  ItemConfig,
  VariableConfig,
  TimelineConfig,
  WorldConfig,
  FactionConfig,
  LocationConfig,
  ActionConfig,
  EventConfig,
  DialogueConfig,
  AiModelConfig,
}
